import { constants } from '../config';
/* **** showCookies *** */
export const showCookies = (show) => ({
  type: constants.SHOW_COOKIES,
  show,
});
